(() => {
  const Q = [100, 200, 300, 400, 500, 1e3],
    CLASSIC = [199, 189, 179, 175, 169, 149],
    LUXE = [299, 279, 259, 249, 229, 199],
    SCREWS = [3e3, 5e3, 7e3, 8500, 1e4, 18e3],
    W = 1500,
    FONTS = [
      "Arial",
      "Verdana",
      "Montserrat",
      "Orbitron",
      "Michroma",
      "Dancing Script",
    ],
    ICONS = {
      car1: { label: "Silhouette automobile 1", image: "car1", ratio: 5.2 },
      car2: { label: "Silhouette automobile 2", image: "car2", ratio: 5.2 },
      car3: { label: "Silhouette automobile 3", image: "car3", ratio: 5.2 },
      car4: { label: "Silhouette automobile 4", image: "car4", ratio: 5.2 },
      car5: { label: "Silhouette automobile 5", image: "car5", ratio: 5.2 },
      car6: { label: "Silhouette automobile 6", image: "car6", ratio: 5.2 },
      car7: { label: "Silhouette automobile 7", image: "car7", ratio: 5.2 },
      car8: { label: "Silhouette automobile 8", image: "car8", ratio: 5.2 },
      car9: { label: "Silhouette automobile 9", image: "car9", ratio: 5.2 },
      car10: { label: "Silhouette automobile 10", image: "car10", ratio: 5.2 },
      car11: { label: "Silhouette automobile 11", image: "car11", ratio: 5.2 },
      car12: { label: "Silhouette automobile 12", image: "car12", ratio: 5.2 },
      car13: { label: "Silhouette automobile 13", image: "car13", ratio: 5.2 },
      car14: { label: "Silhouette automobile 14", image: "car14", ratio: 5.2 },
      car15: { label: "Silhouette automobile 15", image: "car15", ratio: 5.2 },
      car16: { label: "Silhouette automobile 16", image: "car16", ratio: 5.2 },
      car17: { label: "Silhouette automobile 17", image: "car17", ratio: 5.2 },
      car18: { label: "Silhouette automobile 18", image: "car18", ratio: 5.2 },
      car19: { label: "Silhouette automobile 19", image: "car19", ratio: 5.2 },
      car20: { label: "Silhouette automobile 20", image: "car20", ratio: 5.2 },
      dot: {
        label: "Point",
        path: "M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z",
        rule: "nonzero",
        ratio: 1,
      },
      email: {
        label: "E-mail",
        ratio: 1.5,
        stroke: !0,
        path: "M5 5h14a3 3 0 0 1 3 3v8a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V8a3 3 0 0 1 3-3Z M3 6l9 8 9-8 M3 18l6-6 M21 18l-6-6",
      },
      website: {
        label: "Site web",
        ratio: 1,
        stroke: !0,
        path: "M22 12a10 10 0 1 1-20 0 10 10 0 0 1 20 0Z M17 12c0 5.5-2.2 10-5 10s-5-4.5-5-10S9.2 2 12 2s5 4.5 5 10Z M12 2v20 M2 12h20 M4 6c5 3 11 3 16 0 M4 18c5-3 11-3 16 0",
      },
      phone: {
        label: "T\xE9l\xE9phone",
        path: "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z",
        rule: "nonzero",
        ratio: 1,
      },
      whatsapp: {
        label: "WhatsApp",
        ratio: 1,
        rule: "nonzero",
        path: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z",
      },
      star: {
        label: "\xC9toile",
        path: "M12 2 15 9 22 9.5 16.5 14 18.5 21 12 17 5.5 21 7.5 14 2 9.5 9 9Z",
        rule: "nonzero",
        ratio: 1,
      },
      pin: {
        label: "Localisation",
        path: "M12 2C7.58 2 4 5.58 4 10c0 5.25 6.72 11.34 7.39 11.93a.9.9 0 0 0 1.22 0C13.28 21.34 20 15.25 20 10c0-4.42-3.58-8-8-8Zm0 11a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z",
        rule: "evenodd",
        ratio: 1,
      },
      mobile: {
        label: "Mobile",
        path: "M9.5 1h5A2.5 2.5 0 0 1 17 3.5v17a2.5 2.5 0 0 1-2.5 2.5h-5A2.5 2.5 0 0 1 7 20.5v-17A2.5 2.5 0 0 1 9.5 1Z",
        rule: "nonzero",
        ratio: 1,
      },
      plus: {
        label: "Croix",
        path: "M9 2h6v7h7v6h-7v7H9v-7H2V9h7Z",
        rule: "nonzero",
        ratio: 1,
      },
      arrow: {
        label: "Fl\xE8che",
        path: "M2 7h12V2l8 10-8 10v-5H2Z",
        rule: "nonzero",
        ratio: 1,
      },
      instagram: {
        label: "Instagram",
        path: "M7 1h10a6 6 0 0 1 6 6v10a6 6 0 0 1-6 6H7a6 6 0 0 1-6-6V7a6 6 0 0 1 6-6Zm0 2a4 4 0 0 0-4 4v10a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4Zm5 3a6 6 0 1 1 0 12 6 6 0 0 1 0-12Zm0 2a4 4 0 1 0 0 8 4 4 0 0 0 0-8Zm6-4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Z",
        rule: "evenodd",
        ratio: 1,
      },
      facebook: {
        label: "Facebook",
        path: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24Zm1.8 22V13h3l.5-3h-3.5V8c0-1 .5-1.5 1.5-1.5h2V3.8l-2.5-.3c-3 0-4.2 1.8-4.2 4.5v2H8v3h2.6v9Z",
        rule: "evenodd",
        ratio: 1,
      },
      tiktok: {
        label: "TikTok",
        path: "M14 1h3c0 3 2 5 5 5v3c-2 0-4-.6-5-1.5V17a7 7 0 1 1-7-7v3a4 4 0 1 0 4 4Z",
        rule: "nonzero",
        ratio: 1,
      },
      mechanic: {
        label: "M\xE9canicien",
        image: "mechanic",
        ratio: 1,
        luminanceMask: !0,
      },
      tyreFlame: {
        label: "Pneu avec flammes",
        image: "tyreFlame",
        ratio: 1,
        luminanceMask: !0,
      },
      tyreSpeed: {
        label: "Pneu en mouvement",
        image: "tyreSpeed",
        ratio: 1,
        luminanceMask: !0,
      },
    };
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = "true";
    const cfg = JSON.parse(root.querySelector("[data-settings]").textContent),
      S = cfg.strings,
      $ = (s) => root.querySelector(s),
      $$ = (s) => [...root.querySelectorAll(s)],
      money = (n) =>
        new Intl.NumberFormat("fr-BE", {
          style: "currency",
          currency: "EUR",
        }).format(n / 100),
      esc = (s) =>
        String(s).replace(
          /[&<>"']/g,
          (c) =>
            ({
              "&": "&amp;",
              "<": "&lt;",
              ">": "&gt;",
              '"': "&quot;",
              "'": "&#39;",
            })[c],
        ),
      cv = $("[data-preview]"),
      editor = $("[data-editor]"),
      final = $("[data-final]"),
      ctx = document.createElement("canvas").getContext("2d"),
      images = {},
      iconImages = {},
      assets = new Map(),
      files = new Map(),
      key = "plakperso-b2b-v1",
      history = [],
      future = [],
      trash =
        '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 6h18M9 6V3h6v3M5 6l1 15h12l1-15M10 10v7M14 10v7"/></svg>',
      dbPromise = new Promise((resolve, reject) => {
        const req = indexedDB.open("plakperso-b2b-assets", 1);
        ((req.onupgradeneeded = () => req.result.createObjectStore("logos")),
          (req.onsuccess = () => resolve(req.result)),
          (req.onerror = () => resolve(null)));
      }),
      assetStore = async (action, key2, value) => {
        const db = await dbPromise;
        return db
          ? new Promise((resolve, reject) => {
              const tx = db.transaction(
                  "logos",
                  action === "get" ? "readonly" : "readwrite",
                ),
                store = tx.objectStore("logos"),
                req =
                  action === "get"
                    ? store.get(key2)
                    : action === "put"
                      ? store.put(value, key2)
                      : store.delete(key2);
              ((req.onsuccess = () => resolve(req.result)),
                (req.onerror = () => reject(req.error)));
            })
          : null;
      };
    let state = {
        version: 1,
        range: "visser",
        qty: 200,
        quantityChosen: !1,
        plates: [],
        screws: !1,
        finish: "classic",
        elements: [],
        step: 1,
      },
      selected = null,
      busy = !1,
      drag = null,
      revision = 0,
      pendingReference = null,
      pendingRevision = -1,
      H = 140;
    const unit = () =>
        (state.range === "luxe" ? LUXE : CLASSIC)[Q.indexOf(state.qty)],
      colors = () => {
        const inks = new Set();
        let multi = !1;
        for (const e of state.elements)
          e.kind === "logo"
            ? e.colors >= 2
              ? (multi = !0)
              : inks.add(e.ink.toLowerCase())
            : e.kind !== "logo" &&
                state.range === "luxe" &&
                state.finish !== "classic"
              ? inks.add(state.finish)
              : inks.add(e.color.toLowerCase());
        return {
          count: Math.max(inks.size, multi ? 2 : 0),
          inks: [...inks],
          hasMulticolorLogo: multi,
          multi: multi || inks.size >= 2,
        };
      },
      total = () =>
        state.qty * (unit() + (colors().multi ? 20 : 0)) +
        (state.range === "visser" && state.screws
          ? SCREWS[Q.indexOf(state.qty)]
          : 0),
      el = () => state.elements.find((e) => e.id === selected),
      model = () => S[state.range],
      id = () => crypto.randomUUID(),
      dimKey = () => (state.range === "visser" ? "visser" : "clipser"),
      physical = () => ({
        width: Number(cfg.width[dimKey()]),
        height: Number(cfg.height[dimKey()]),
      }),
      minSize = (e) => {
        const d = physical(),
          mm = e.kind === "text" ? Number(cfg.minText) : Number(cfg.minLogo);
        return d.height > 0 && mm > 0
          ? Math.max(8, Math.ceil((H * mm) / d.height) + 4)
          : e.kind === "text"
            ? Math.ceil(H * 0.2)
            : Math.ceil(H * 0.17);
      };
    function geometry() {
      const next = state.range === "visser" ? 44 : 57,
        old = state.coordinateHeight || 140;
      if (old !== next)
        for (const e of state.elements)
          ((e.size *= next / old), (e.y *= next / old));
      ((state.coordinateHeight = next), (H = next));
    }
    function error(message) {
      (($("[data-error]").textContent = message || ""),
        ($("[data-error]").hidden = !message));
    }
    function checkpoint() {
      (history.push(JSON.stringify(state)),
        history.length > 50 && history.shift(),
        (future.length = 0));
    }
    function save() {
      (revision++, ($("[data-accept]").checked = !1));
      try {
        sessionStorage.setItem(key, JSON.stringify(state));
      } catch {}
    }
    function measure(e) {
      if (e.kind === "text") {
        ctx.font = `${e.font === "Michroma" ? 400 : 700} ${e.size}px "${e.font}"`;
        const m = ctx.measureText(e.text);
        ((e.w =
          Math.ceil(
            Math.max(
              m.width,
              (m.actualBoundingBoxLeft || 0) + (m.actualBoundingBoxRight || 0),
            ),
          ) + 2),
          (e.h =
            Math.ceil(
              (m.actualBoundingBoxAscent ?? e.size * 0.8) +
                (m.actualBoundingBoxDescent ?? e.size * 0.2),
            ) + 2),
          (e.ascent = m.actualBoundingBoxAscent ?? e.size * 0.8),
          (e.bearing = m.actualBoundingBoxLeft || 0));
      } else
        (e.kind === "icon" &&
          (e.ratio = iconImages[e.icon]
            ? iconImages[e.icon].naturalWidth / iconImages[e.icon].naturalHeight
            : ICONS[e.icon]?.ratio || 1),
          (e.h = e.size),
          (e.w = e.size * e.ratio));
      return e.w <= W - 4 && e.h <= H - 4;
    }
    function constrain(e) {
      e.size = Math.max(
        minSize(e),
        e.kind === "logo" ? minSize(e) / Math.min(1, e.ratio) : 0,
        Math.min(e.kind === "text" ? H * 1.5 : H - 4, Number(e.size) || 64),
      );
      let fits = measure(e);
      if (!fits)
        for (let attempt = 0; attempt < 6 && !fits; attempt++)
          ((e.size = Math.max(
            minSize(e),
            Math.floor(e.size * Math.min((W - 4) / e.w, (H - 4) / e.h) * 0.98),
          )),
            (fits = measure(e)));
      return fits
        ? ((e.x = Math.max(2, Math.min(W - 2 - e.w, Number(e.x) || 2))),
          (e.y = Math.max(2, Math.min(H - 2 - e.h, Number(e.y) || 2))),
          !0)
        : !1;
    }
    function valid() {
      return (
        state.elements.length > 0 &&
        state.elements.every(
          (e) =>
            (e.kind !== "text" || e.text.trim().length > 0) &&
            constrain(e) &&
            e.size >= minSize(e) &&
            (!e.kind || e.kind !== "logo" || files.has(e.asset)),
        )
      );
    }
    function change(fn) {
      const before = JSON.stringify(state);
      return (
        checkpoint(),
        fn(),
        geometry(),
        state.elements.every(constrain)
          ? (error(), save(), render(), !0)
          : ((state = JSON.parse(before)),
            history.pop(),
            error(S.error_bounds),
            !1)
      );
    }
    function fill(e, x) {
      if (
        state.range === "luxe" &&
        e.kind !== "logo" &&
        state.finish !== "classic"
      ) {
        const g = x.createLinearGradient(0, e.y, 0, e.y + e.h),
          gold = state.finish.startsWith("gold");
        return state.finish.endsWith("matte")
          ? gold
            ? "#c2a251"
            : "#b4b4b4"
          : (g.addColorStop(0, gold ? "#f6e4ad" : "#f4f4f4"),
            g.addColorStop(0.4, gold ? "#af7f24" : "#777"),
            g.addColorStop(0.55, gold ? "#ffe7a2" : "#fff"),
            g.addColorStop(1, gold ? "#b08839" : "#9a9a9a"),
            g);
      }
      return e.color;
    }
    function drawStrip(target, selection = !1) {
      const x = target.getContext("2d");
      x.clearRect(0, 0, W, H);
      const bg = x.createLinearGradient(0, 0, 0, H);
      (bg.addColorStop(0, "#252525"),
        bg.addColorStop(0.16, "#070707"),
        bg.addColorStop(1, "#111"),
        (x.fillStyle = bg),
        x.fillRect(0, 0, W, H),
        (x.strokeStyle = "#ffffff25"),
        x.strokeRect(0.5, 0.5, W - 1, H - 1));
      for (const e of state.elements) {
        if (
          (x.save(),
          e.kind !== "text" &&
            e.flip &&
            (x.translate(2 * e.x + e.w, 0), x.scale(-1, 1)),
          e.kind === "text")
        )
          ((x.font = `${e.font === "Michroma" ? 400 : 700} ${e.size}px "${e.font}"`),
            (x.textBaseline = "alphabetic"),
            state.range === "luxe" &&
              ((x.shadowColor = "#000"),
              (x.shadowBlur = 2),
              (x.shadowOffsetX = 2),
              (x.shadowOffsetY = 3)),
            (x.fillStyle = fill(e, x)),
            x.fillText(e.text, e.x + 1 + e.bearing, e.y + 1 + e.ascent));
        else if (e.kind === "icon") {
          const icon = ICONS[e.icon],
            img = iconImages[e.icon];
          if (icon?.image && img) {
            const mask = document.createElement("canvas");
            ((mask.width = img.naturalWidth),
              (mask.height = img.naturalHeight));
            const mx = mask.getContext("2d");
            (mx.drawImage(img, 0, 0),
              (mx.globalCompositeOperation = "source-in"),
              (mx.fillStyle = fill(e, x)),
              mx.fillRect(0, 0, mask.width, mask.height),
              x.drawImage(mask, e.x, e.y, e.w, e.h));
          } else
            icon?.path &&
              (x.translate(e.x, e.y),
              x.scale(e.w / 24, e.h / 24),
              icon.stroke
                ? ((x.strokeStyle = fill(e, x)),
                  (x.lineWidth = 1.6),
                  (x.lineJoin = "round"),
                  (x.lineCap = "round"),
                  x.stroke(new Path2D(icon.path)))
                : ((x.fillStyle = fill(e, x)),
                  x.fill(new Path2D(icon.path), icon.rule)));
        } else if (e.kind === "logo") {
          const a = assets.get(e.asset);
          a && x.drawImage(a, e.x, e.y, e.w, e.h);
        }
        (x.restore(),
          selection &&
            selected === e.id &&
            ((x.strokeStyle = "#ff4d55"),
            (x.lineWidth = 2),
            x.strokeRect(e.x - 1, e.y - 1, e.w + 2, e.h + 2)));
      }
    }
    function drawPreview(target, selection = !1) {
      const x = target.getContext("2d"),
        img = images[dimKey()];
      if (
        ((x.fillStyle = "#fff"),
        x.fillRect(0, 0, target.width, target.height),
        !img)
      )
        return;
      x.drawImage(img, 0, 0, target.width, target.height);
      const zone =
          state.range === "visser"
            ? { x: 0.029, y: 0.845, w: 0.94, h: 0.102 }
            : { x: 0.029, y: 0.832, w: 0.94, h: 0.132 },
        exportStrip = document.createElement("canvas");
      ((exportStrip.width = W),
        (exportStrip.height = H),
        drawStrip(exportStrip, selection),
        x.drawImage(
          exportStrip,
          zone.x * target.width,
          zone.y * target.height,
          zone.w * target.width,
          zone.h * target.height,
        ));
    }
    function impression() {
      return (
        (colors().multi ? "Multicolore" : "Monochrome") +
        (state.range === "visser" && state.screws ? " avec vis" : " sans vis")
      );
    }
    function variant() {
      return cfg.product?.variants?.find(
        (v) =>
          v.options?.[0] === model() &&
          v.options?.[1] === String(state.qty) &&
          v.options?.[2] === impression(),
      );
    }
    function ready() {
      const v = variant(),
        expected = Math.round(
          total() * (cfg.taxesIncluded ? 1 + Number(cfg.taxRate) / 100 : 1),
        ),
        baseMarket = cfg.country === "BE" && cfg.currency === "EUR";
      return !!(
        cfg.enabled &&
        cfg.shippingValidated &&
        v?.available &&
        [
          59579630125381, 59579630158149, 59579630190917, 59579630223685,
          59579630256453, 59579630289221, 59579630321989, 59579630354757,
          59579630387525, 59579630420293, 59579630453061, 59579630485829,
          59579630518597, 59579630551365, 59579630584133, 59579630616901,
          59579630649669, 59579630682437, 59579630715205, 59579630747973,
          59579630780741, 59579630813509, 59579630846277, 59579630879045,
          59579630911813, 59579630944581, 59579630977349, 59579631010117,
          59579631042885, 59579631075653, 59579631108421, 59579631141189,
          59579631173957, 59579631206725, 59579631239493, 59579631272261,
          59579631305029, 59579631337797, 59579631370565, 59579631403333,
          59579631436101, 59579631468869, 59579631501637, 59579631534405,
          59579631567173, 59579631599941, 59579631632709, 59579631665477,
        ].includes(Number(v.id)) &&
        (!baseMarket || Math.abs(Number(v.price) - expected) <= 1)
      );
    }
    function sizeBounds(e) {
      const low = Math.max(
          minSize(e),
          e.kind === "logo" ? minSize(e) / Math.min(1, e.ratio) : 0,
        ),
        probe = { ...e };
      let a = low,
        b = e.kind === "text" ? H * 1.5 : H - 4;
      for (let i = 0; i < 24; i++) {
        const mid = (a + b) / 2;
        ((probe.size = mid), measure(probe) ? (a = mid) : (b = mid));
      }
      return { low, high: Math.max(low, a) };
    }
    function sizeLevel(e) {
      const { low, high } = sizeBounds(e);
      return high - low < 0.01
        ? 0
        : Math.max(
            0,
            Math.min(10, Math.round(((e.size - low) / (high - low)) * 10)),
          );
    }
    function resizeElement(e, step) {
      const { low, high } = sizeBounds(e),
        level = Math.max(0, Math.min(10, sizeLevel(e) + step)),
        cx = e.x + e.w / 2,
        cy = e.y + e.h / 2;
      ((e.size = low + ((high - low) * level) / 10),
        measure(e),
        (e.x = cx - e.w / 2),
        (e.y = cy - e.h / 2));
    }
    function alignElement(e, side) {
      measure(e);
      const margin = Math.min(24, Math.max(2, (W - e.w) / 2));
      ((e.x =
        side === "left"
          ? margin
          : side === "right"
            ? W - margin - e.w
            : (W - e.w) / 2),
        (e.y = (H - e.h) / 2));
    }
    function displayProperties() {
      const e = el();
      if (
        (($("[data-properties]").hidden = !e),
        ($("[data-empty]").hidden = !!e),
        !e)
      )
        return;
      (($("[data-text-fields]").hidden = e.kind !== "text"),
        ($("[data-color-fields]").hidden = e.kind === "logo"),
        ($("[data-logo-fields]").hidden = e.kind !== "logo"),
        e.kind === "text" &&
          (($("[data-font]").value = e.font),
          ($("[data-font]").style.fontFamily = e.font)),
        e.kind !== "logo" &&
          ($$("[data-swatch]").forEach((n) =>
            n.setAttribute(
              "aria-pressed",
              (state.range !== "luxe" || state.finish === "classic") &&
                n.dataset.swatch === e.color,
            ),
          ),
          ($("[data-color-fields] [data-selected-color]").textContent =
            state.range === "luxe" && state.finish !== "classic"
              ? S[state.finish]
              : e.color)),
        e.kind === "logo" &&
          (($("[data-logo-colors]").value = String(e.colors)),
          $$("[data-logo-swatch]").forEach((n) =>
            n.setAttribute("aria-pressed", n.dataset.logoSwatch === e.ink),
          ),
          ($("[data-logo-fields] [data-selected-color]").textContent = e.ink)));
      const level = sizeLevel(e);
      (($("[data-size-label]").textContent = level + " / 10"),
        ($('[data-action="smaller"]').disabled = level === 0),
        ($('[data-action="larger"]').disabled = level === 10),
        $("[data-size-scale]").setAttribute("aria-valuenow", level),
        $$("[data-size-tick]").forEach((n) =>
          n.classList.toggle("is-active", Number(n.dataset.sizeTick) === level),
        ),
        ($('[data-action="flip"]').hidden = e.kind === "text"),
        $('[data-action="flip"]').setAttribute(
          "aria-pressed",
          String(!!e.flip),
        ));
    }
    function summary() {
      const tax = Math.round((total() * Number(cfg.taxRate)) / 100),
        rows = [
          ["range", model()],
          ["quantity", `${state.qty} ${S.quantity_pieces}`],
          ["unit", money(unit())],
          [
            "color_count",
            String(colors().count) + (colors().hasMulticolorLogo ? "+" : ""),
          ],
          ["extra", `${money(colors().multi ? 20 : 0)} / ${S.quantity_pieces}`],
          [
            "screw_price",
            money(
              state.range === "visser" && state.screws
                ? SCREWS[Q.indexOf(state.qty)]
                : 0,
            ),
          ],
          ["total", money(total())],
          ["tax", money(tax)],
          ["gross", money(total() + tax)],
          ...((state.plates || []).length
            ? [
                [
                  "plexi_gross",
                  money(
                    state.plates.reduce(
                      (t, p) => t + p.quantity * cfg.plateVariant.price,
                      0,
                    ),
                  ),
                ],
                [
                  "order_gross",
                  money(
                    total() +
                      tax +
                      state.plates.reduce(
                        (t, p) => t + p.quantity * cfg.plateVariant.price,
                        0,
                      ),
                  ),
                ],
              ]
            : []),
          ["delay", `${state.range === "luxe" ? 6 : 3} ${S.weeks}`],
          ["delivery_label", S.delivery_help],
        ];
      $("[data-summary]").innerHTML = rows
        .map(
          ([k, v]) =>
            `<div class="${k === "total" ? "ppc-total" : ""}"><dt>${esc(S[k])}</dt><dd>${esc(v)}</dd></div>`,
        )
        .join("");
    }
    function render(properties = !0) {
      const focused = document.activeElement,
        editing = focused?.dataset?.layerText,
        caret = editing ? focused.selectionStart : null,
        end = editing ? focused.selectionEnd : null;
      geometry();
      for (const e of state.elements) constrain(e);
      ($$("[data-step]").forEach(
        (n) => (n.hidden = Number(n.dataset.step) !== state.step),
      ),
        $$("[data-step-link]").forEach((n) => {
          (n.setAttribute(
            "aria-current",
            Number(n.dataset.stepLink) === state.step ? "step" : "false",
          ),
            (n.disabled =
              Number(n.dataset.stepLink) > state.step &&
              Number(n.dataset.stepLink) > 2 &&
              !state.elements.length));
        }),
        $$("[data-range]").forEach((n) =>
          n.setAttribute("aria-pressed", n.dataset.range === state.range),
        ),
        ($("[data-quantities]").innerHTML = Q.map(
          (q, i) =>
            `<button type="button" data-qty="${q}" aria-pressed="${state.quantityChosen && q === state.qty}">${q === 200 ? `<b>${esc(S.popular)}</b>` : ""}<strong>${q}</strong><small>${money((state.range === "luxe" ? LUXE : CLASSIC)[i])} HTVA / ${esc(S.quantity_pieces)}</small></button>`,
        ).join("")),
        ($("[data-model]").textContent = state.quantityChosen
          ? `${model()} \xB7 ${state.qty} ${S.quantity_pieces}`
          : model()),
        ($("[data-price]").textContent = `${money(total())} HTVA`),
        ($("[data-bottom-price]").textContent = `${money(total())} HTVA`),
        ($("[data-unit]").textContent =
          `${money(unit() + (colors().multi ? 20 : 0))} HTVA / ${S.quantity_pieces}`));
      for (const n of $$("[data-price],[data-bottom-price],[data-unit]"))
        n.hidden = state.step === 1 || !state.quantityChosen;
      $("[data-delay]").textContent =
        `${S.delay} : ${state.range === "luxe" ? 6 : 3} ${S.weeks}`;
      const existingLayers = [...$("[data-layers]").children];
      if (
        ((editing &&
          existingLayers.length === state.elements.length &&
          existingLayers.every(
            (n, i) =>
              (n.querySelector("[data-layer-text]")?.dataset.layerText ||
                n.querySelector("[data-element]")?.dataset.element) ===
              state.elements[i].id,
          )) ||
          ($("[data-layers]").innerHTML = state.elements
            .map(
              (e, i) =>
                `<div class="ppc-layer" data-selected="${selected === e.id}">${e.kind === "text" ? `<input type="text" data-layer-text="${e.id}" value="${esc(e.text)}" maxlength="120" aria-label="${esc(S.text)} ${i + 1}">` : `<button type="button" data-element="${e.id}" aria-pressed="${selected === e.id}">${esc(e.kind === "logo" ? e.name : ICONS[e.icon]?.label || S[e.icon])}</button>`}<button type="button" class="ppc-trash" data-delete-element="${e.id}" aria-label="${esc(S.delete)} ${esc(e.kind === "text" ? e.text : e.kind === "logo" ? e.name : ICONS[e.icon]?.label)}" title="${esc(S.delete)}">${trash}</button></div>`,
            )
            .join("")),
        ($("[data-luxe]").hidden =
          state.range !== "luxe" || !el() || el().kind === "logo"),
        ($("[data-finish]").value = state.finish),
        $$("[data-finish-choice]").forEach((n) =>
          n.setAttribute(
            "aria-pressed",
            n.dataset.finishChoice === state.finish,
          ),
        ),
        ($("[data-screw-option]").hidden = state.range !== "visser"),
        ($("[data-no-screws]").hidden = state.range === "visser"),
        ($("[data-screws]").checked = state.screws),
        ($("[data-screws-price]").textContent =
          `${money(SCREWS[Q.indexOf(state.qty)])} HTVA`),
        ($("[data-screws-quantity]").textContent =
          `4 \xD7 ${state.qty} porte-plaques = ${state.qty * 4} vis`),
        ($("[data-gate]").hidden = ready()),
        ($("[data-buy]").disabled =
          !ready() || !$("[data-accept]").checked || busy),
        (root.querySelector("[data-action=back]").disabled = state.step === 1),
        (root.querySelector("[data-action=next]").hidden = state.step === 5),
        (root.querySelector("[data-action=undo]").disabled = !history.length),
        (root.querySelector("[data-action=redo]").disabled = !future.length),
        properties && displayProperties(),
        editing)
      ) {
        const field = $$("[data-layer-text]").find(
          (n) => n.dataset.layerText === editing,
        );
        field &&
          ((field.value =
            state.elements.find((e) => e.id === editing)?.text || ""),
          field.focus({ preventScroll: !0 }),
          caret !== null && field.setSelectionRange(caret, end));
      }
      (drawPreview(cv, !0),
        drawPreview(final),
        summary(),
        $("[data-plate-list]") && renderPlates());
    }
    async function fontReady(font) {
      if (["Arial", "Verdana"].includes(font)) return;
      if (
        !(
          await document.fonts.load(
            `${font === "Michroma" ? 400 : 700} 64px "${font}"`,
          )
        ).length
      )
        throw Error(S.error_fonts);
    }
    function place(e) {
      if (!constrain(e)) return;
      const xs = [24, ...state.elements.map((n) => n.x + n.w + 20)],
        ys = [(H - e.h) / 2, 4, ...state.elements.map((n) => n.y + n.h + 12)];
      for (const y of ys)
        for (const x of xs)
          if (
            !(x + e.w > W - 4 || y + e.h > H - 4 || y < 4) &&
            state.elements.every(
              (n) =>
                x + e.w + 8 < n.x ||
                x > n.x + n.w + 8 ||
                y + e.h + 8 < n.y ||
                y > n.y + n.h + 8,
            )
          ) {
            ((e.x = x), (e.y = y));
            return;
          }
    }
    async function addText() {
      if (state.elements.length >= 20) {
        error(S.max_elements);
        return;
      }
      const e = {
        id: id(),
        kind: "text",
        text: "PLAKPERSO CARS",
        font: "Arial",
        color: "#ffffff",
        ral: "",
        size: 64,
        x: 40,
        y: 30,
      };
      (place(e),
        change(() => state.elements.push(e)) && ((selected = e.id), render()));
    }
    function chooseRange(range) {
      ["visser", "clipser", "luxe"].includes(range) &&
        change(() => {
          (state.range !== range && (state.quantityChosen = !1),
            (state.range = range),
            range !== "visser" && (state.screws = !1),
            range !== "luxe" && (state.finish = "classic"),
            (state.step = 2));
        });
    }
    function goto(step) {
      if ((finishDrag(), step > 3 && !valid())) {
        error(S.empty);
        return;
      }
      if (step > 2 && !state.quantityChosen) {
        error("Choisissez votre quantit\xE9 avant de continuer.");
        return;
      }
      ((state.step = Math.max(1, Math.min(5, step))),
        error(),
        render(),
        root
          .querySelector(`[data-step="${state.step}"] h3`)
          ?.focus({ preventScroll: !0 }),
        root.scrollIntoView({ behavior: "smooth", block: "start" }));
    }
    function serialize(reference) {
      const d = physical();
      return {
        schema: "plakperso.b2b.v1",
        reference,
        range: state.range,
        rangeLabel: model(),
        quantity: state.qty,
        unitHTCents: unit(),
        colorSurchargeHTCents: colors().multi ? 20 : 0,
        totalHTCents: total(),
        colors: colors(),
        finish: state.finish,
        finishLabel: S[state.finish],
        screws: state.range === "visser" && state.screws,
        screwQuantity:
          state.range === "visser" && state.screws ? state.qty * 4 : 0,
        preparationWeeks: state.range === "luxe" ? 6 : 3,
        dimensionsMm: d,
        coordinateSpace: { width: W, height: H },
        minimumTextMm: cfg.minText,
        minimumLogoMm: cfg.minLogo,
        manufacturingValidated: cfg.manufacturingValidated,
        elements: state.elements.map((e) => {
          const out = {
            ...e,
            xMm: d.width ? (e.x / W) * d.width : null,
            yMm: d.height ? (e.y / H) * d.height : null,
            widthMm: d.width ? (e.w / W) * d.width : null,
            heightMm: d.height ? (e.h / H) * d.height : null,
          };
          return (delete out.ascent, delete out.bearing, out);
        }),
      };
    }
    function svgPreview(text) {
      if (/<!ENTITY/i.test(text)) throw Error(S.error_svg);
      const doc = new DOMParser().parseFromString(text, "image/svg+xml"),
        svg = doc.documentElement;
      if (doc.querySelector("parsererror") || svg.localName !== "svg")
        throw Error(S.error_svg);
      const safeUrls = (value) =>
        [...value.matchAll(/url\s*\(\s*(['"]?)(.*?)\1\s*\)/gi)].every((m) =>
          m[2].trim().startsWith("#"),
        );
      for (const n of doc.querySelectorAll("*")) {
        if (
          /^(script|foreignObject|iframe|object|embed|audio|video|animate|animateTransform|animateMotion|set)$/i.test(
            n.localName,
          )
        )
          throw Error(S.error_svg);
        for (const a of n.attributes)
          if (
            /^on/i.test(a.name) ||
            (/href$/i.test(a.name) &&
              !a.value.trim().startsWith("#") &&
              !/^data:image\/(png|jpeg);base64,/i.test(a.value.trim())) ||
            !safeUrls(a.value) ||
            /@import/i.test(a.value)
          )
            throw Error(S.error_svg);
        if (
          n.localName === "style" &&
          (/@import/i.test(n.textContent) || !safeUrls(n.textContent))
        )
          throw Error(S.error_svg);
      }
      const vb = (svg.getAttribute("viewBox") || "")
          .trim()
          .split(/[\s,]+/)
          .map(Number),
        hasViewBox =
          vb.length === 4 &&
          vb.every(Number.isFinite) &&
          vb[2] > 0 &&
          vb[3] > 0,
        width = svg.getAttribute("width"),
        height = svg.getAttribute("height");
      return (
        (!width || width.endsWith("%")) &&
          svg.setAttribute("width", hasViewBox ? vb[2] : 1e3),
        (!height || height.endsWith("%")) &&
          svg.setAttribute("height", hasViewBox ? vb[3] : 500),
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg"),
        new Blob([new XMLSerializer().serializeToString(svg)], {
          type: "image/svg+xml",
        })
      );
    }
    async function loadLogo(file) {
      const isSvg = /\.svg$/i.test(file.name) || file.type === "image/svg+xml",
        source = isSvg ? svgPreview(await file.text()) : file,
        url = URL.createObjectURL(source),
        image = new Image();
      try {
        if (
          (await new Promise((resolve, reject) => {
            ((image.onload = resolve),
              (image.onerror = () => reject(Error(S.error_image))),
              (image.src = url));
          }),
          !image.naturalWidth ||
            !image.naturalHeight ||
            image.naturalWidth > 2e4 ||
            image.naturalHeight > 2e4)
        )
          throw Error(S.error_image);
        return image;
      } finally {
        URL.revokeObjectURL(url);
      }
    }
    async function upload(list) {
      for (const f of list) {
        if (state.elements.length >= 20) {
          error(S.max_elements);
          break;
        }
        if (
          f.size > 5 * 1024 * 1024 ||
          !(
            /\.(png|jpe?g|svg)$/i.test(f.name) ||
            ["image/png", "image/jpeg", "image/svg+xml"].includes(f.type)
          )
        ) {
          error(S.error_upload);
          continue;
        }
        try {
          const image = await loadLogo(f),
            token = id();
          (assets.set(token, image),
            files.set(token, f),
            await assetStore("put", token, f).catch(() => null));
          const ratio = image.width / image.height,
            size = Math.max(
              minSize({ kind: "logo" }),
              Math.min(90, (W - 8) / ratio),
            ),
            e = {
              id: id(),
              kind: "logo",
              asset: token,
              name: f.name,
              colors: 2,
              ink: "#ffffff",
              ral: "",
              ratio,
              size,
              x: 60,
              y: 20,
            };
          if (!constrain(e)) throw Error(S.error_bounds);
          (place(e),
            change(() => state.elements.push(e)),
            (selected = e.id),
            render());
        } catch (err) {
          error(err.message);
        }
      }
      $("[data-logo-upload]").value = "";
    }
    async function send(event) {
      if (
        (event.preventDefault(),
        busy || !ready() || !valid() || !$("[data-accept]").checked)
      )
        return;
      ((busy = !0), render(!1), ($("[data-buy]").textContent = S.prepare));
      const configRevision = revision;
      try {
        if (
          (await Promise.all(
            [
              ...new Set(
                state.elements
                  .filter((e) => e.kind === "text")
                  .map((e) => e.font),
              ),
            ].map(fontReady),
          ),
          !state.elements.every(constrain))
        )
          throw Error(S.error_bounds);
        if (
          !images[dimKey()] ||
          state.elements.some(
            (e) =>
              e.kind === "icon" && ICONS[e.icon]?.image && !iconImages[e.icon],
          )
        )
          throw Error(S.error_image);
        drawPreview(final);
        const blob = await new Promise((resolve, reject) =>
          final.toBlob(
            (b) => (b ? resolve(b) : reject(Error(S.error_image))),
            "image/png",
          ),
        );
        if (configRevision !== revision) throw Error(S.error_cart);
        const reference =
          pendingRevision === revision && pendingReference
            ? pendingReference
            : "PPB-" +
              Date.now().toString(36).toUpperCase() +
              "-" +
              id().slice(0, 6).toUpperCase();
        ((pendingReference = reference), (pendingRevision = revision));
        const route = cfg.root.endsWith("/") ? cfg.root : cfg.root + "/",
          goCart = () =>
            window.location.assign(
              cfg.shippingCode
                ? route +
                    "discount/" +
                    encodeURIComponent(cfg.shippingCode) +
                    "?redirect=" +
                    encodeURIComponent(cfg.cart)
                : cfg.cart,
            ),
          cartResponse = await fetch(route + "cart.js", {
            headers: { Accept: "application/json" },
          });
        if (!cartResponse.ok) throw Error(S.error_cart);
        const existing = (await cartResponse.json()).items.find(
          (x) =>
            x.properties?.["R\xE9f\xE9rence personnalisation"] === reference,
        );
        if (existing) {
          if (!existing.properties?.["Aper\xE7u de production"])
            throw Error(S.error_cart);
          goCart();
          return;
        }
        const v = variant(),
          record = serialize(reference),
          data = new FormData();
        (data.append("items[0][id]", String(v.id)),
          data.append("items[0][quantity]", "1"),
          data.append("return_to", cfg.cart));
        const props = {
          Gamme: model(),
          "Quantit\xE9 porte-plaques": String(state.qty),
          Finition: S[state.finish],
          "Vis d\u2019installation": state.screws
            ? `4 \xD7 ${state.qty} porte-plaques = ${state.qty * 4} vis`
            : "Sans vis",
          "D\xE9lai approximatif de pr\xE9paration": `${record.preparationWeeks} semaines`,
          "R\xE9f\xE9rence personnalisation": reference,
          Couleurs: state.elements
            .map(
              (e) =>
                `${e.kind === "logo" ? e.ink : e.color}${e.ral ? " / " + e.ral : ""}`,
            )
            .join(" \xB7 "),
          "Texte personnalis\xE9": state.elements
            .filter((e) => e.kind === "text")
            .map((e) => e.text)
            .join(" | "),
          Police: [
            ...new Set(
              state.elements
                .filter((e) => e.kind === "text")
                .map((e) => e.font),
            ),
          ].join(" \xB7 "),
        };
        for (const [k, value] of Object.entries(props))
          data.append(`items[0][properties][${k}]`, value);
        (data.append(
          "items[0][properties][Aper\xE7u de production]",
          new File([blob], reference + ".png", { type: "image/png" }),
        ),
          data.append(
            "items[0][properties][_Fichier technique]",
            new File([JSON.stringify(record, null, 2)], `${reference}-configuration.txt`, {
              type: "text/plain",
            }),
          ),
          state.elements
            .filter((e) => e.kind === "logo")
            .forEach((e, i) =>
              data.append(
                `items[0][properties][Logo original ${i + 1}]`,
                files.get(e.asset),
                files.get(e.asset).name,
              ),
            ));
        for (const [i, p] of (state.plates || []).entries()) {
          (data.append(`items[${i + 1}][id]`, String(cfg.plateVariant.id)),
            data.append(`items[${i + 1}][quantity]`, String(p.quantity)));
          for (const [k, value] of Object.entries({
            "Num\xE9ro de plaque": p.number,
            Matière: "PLEXI",
            Format: "AUTO belge 520 \xD7 110 mm",
            Police: "COMDIV",
            "R\xE9f\xE9rence personnalisation": reference,
            Expédition: "Sous 3 jours ouvrables \u2014 point relais",
            _plakperso_pro_accessory: "plexi",
          }))
            data.append(`items[${i + 1}][properties][${k}]`, value);
        }
        const response = await fetch(
          (cfg.root.endsWith("/") ? cfg.root : cfg.root + "/") + "cart/add.js",
          {
            method: "POST",
            headers: { Accept: "application/json" },
            body: data,
          },
        );
        if (!response.ok) throw Error(S.error_cart);
        const result = await response.json(),
          item =
            result.items?.find((x) => Number(x.variant_id) === Number(v.id)) ||
            result;
        if (
          !item.properties?.["Aper\xE7u de production"] ||
          state.elements
            .filter((e) => e.kind === "logo")
            .some((e, i) => !item.properties?.[`Logo original ${i + 1}`])
        )
          throw Error(S.error_cart);
        goCart();
      } catch (err) {
        (error(err.message || S.error_cart),
          (busy = !1),
          ($("[data-buy]").textContent = S.add_cart),
          render(!1));
      }
    }
    (root.addEventListener("click", async (ev) => {
      const button = ev.target.closest("button");
      if (!button || busy) return;
      if (button.dataset.deleteElement) {
        change(() => {
          ((state.elements = state.elements.filter(
            (e) => e.id !== button.dataset.deleteElement,
          )),
            selected === button.dataset.deleteElement && (selected = null));
        });
        return;
      }
      if (button.dataset.finishChoice) {
        change(() => (state.finish = button.dataset.finishChoice));
        return;
      }
      if (button.dataset.swatch && el()) {
        change(() => {
          ((state.finish = "classic"),
            (el().color = button.dataset.swatch),
            (el().ral = ""));
        });
        return;
      }
      if (button.dataset.logoSwatch && el()) {
        change(() => (el().ink = button.dataset.logoSwatch));
        return;
      }
      if (button.dataset.range) {
        chooseRange(button.dataset.range);
        return;
      }
      if (button.dataset.qty) {
        change(() => {
          ((state.qty = Number(button.dataset.qty)),
            (state.quantityChosen = !0));
        });
        return;
      }
      if (button.dataset.element) {
        ((selected = button.dataset.element), render());
        return;
      }
      if (button.dataset.stepLink) {
        goto(Number(button.dataset.stepLink));
        return;
      }
      if (button.dataset.icon) {
        if (state.elements.length >= 20) {
          error(S.max_elements);
          return;
        }
        const e = {
          id: id(),
          kind: "icon",
          icon: button.dataset.icon,
          color: "#ffffff",
          ratio: ICONS[button.dataset.icon].ratio,
          size: Math.floor(H * 0.65),
          x: 50,
          y: 25,
        };
        (place(e),
          change(() => state.elements.push(e)) &&
            ((selected = e.id), render()));
        return;
      }
      const a = button.dataset.action;
      if (
        (a === "add" && (await addText()),
        a === "delete" &&
          change(() => {
            ((state.elements = state.elements.filter((e) => e.id !== selected)),
              (selected = null));
          }),
        a === "duplicate" && el())
      ) {
        const clone = { ...el(), id: id(), x: el().x + 20 };
        if (state.elements.length >= 20) {
          error(S.max_elements);
          return;
        }
        (change(() => state.elements.push(clone)),
          (selected = clone.id),
          render());
      }
      (["left", "right", "center"].includes(a) &&
        el() &&
        change(() => alignElement(el(), a)),
        ["smaller", "larger"].includes(a) &&
          el() &&
          change(() => resizeElement(el(), a === "larger" ? 1 : -1)),
        a === "flip" &&
          el() &&
          el().kind !== "text" &&
          change(() => (el().flip = !el().flip)),
        a === "undo" &&
          history.length &&
          (future.push(JSON.stringify(state)),
          (state = JSON.parse(history.pop())),
          (selected = null),
          save(),
          render()),
        a === "redo" &&
          future.length &&
          (history.push(JSON.stringify(state)),
          (state = JSON.parse(future.pop())),
          (selected = null),
          save(),
          render()),
        a === "clear" &&
          window.confirm(S.clear_confirm) &&
          (checkpoint(),
          (state.elements = []),
          (selected = null),
          save(),
          render()),
        a === "next" && goto(state.step + 1),
        a === "back" && goto(state.step - 1),
        a === "edit" && goto(3),
        a === "download" &&
          (drawPreview(final),
          final.toBlob((blob) => {
            if (!blob) {
              error(S.error_image);
              return;
            }
            const link = document.createElement("a"),
              url = URL.createObjectURL(blob);
            ((link.href = url),
              (link.download = "plakperso-pro-apercu.png"),
              document.body.appendChild(link),
              link.click(),
              link.remove(),
              setTimeout(() => URL.revokeObjectURL(url), 6e4));
          }, "image/png")));
    }),
      root.closest(".ppb")?.addEventListener("ppb:range", (ev) => {
        chooseRange(
          {
            "\xC0 visser": "visser",
            "\xC0 clipser": "clipser",
            "Luxe 3D": "luxe",
          }[ev.detail],
        );
      }),
      root.addEventListener("focusin", (ev) => {
        const field = ev.target.closest("[data-layer-text]");
        field &&
          selected !== field.dataset.layerText &&
          ((selected = field.dataset.layerText),
          $$("[data-layer-text]").forEach(
            (n) =>
              (n.closest(".ppc-layer").dataset.selected = String(
                n.dataset.layerText === selected,
              )),
          ),
          $$("[data-element]").forEach((n) =>
            n.setAttribute(
              "aria-pressed",
              String(n.dataset.element === selected),
            ),
          ),
          ($("[data-luxe]").hidden = state.range !== "luxe"),
          displayProperties(),
          drawPreview(cv, !0));
      }),
      root.addEventListener("input", (ev) => {
        const field = ev.target.closest("[data-layer-text]");
        field &&
          !busy &&
          ((selected = field.dataset.layerText),
          change(() => (el().text = field.value)));
      }));
    const bind = (selector, fn, event = "change") =>
      $(selector).addEventListener(event, (ev) => {
        if (busy) return;
        const position = ev.target.selectionStart;
        (change(() => {
          el() && fn(el(), ev.target);
        }),
          typeof position == "number" &&
            ev.target.setSelectionRange(position, position));
      });
    (bind("[data-font]", (e, n) => (e.font = n.value)),
      $("[data-font]").addEventListener("change", async () => {
        try {
          (await fontReady(el()?.font), render());
        } catch (err) {
          error(err.message);
        }
      }),
      bind("[data-logo-colors]", (e, n) => (e.colors = Number(n.value))),
      $("[data-screws]").addEventListener("change", (ev) =>
        change(() => (state.screws = ev.target.checked)),
      ),
      $("[data-finish]").addEventListener("change", (ev) =>
        change(() => (state.finish = ev.target.value)),
      ),
      $("[data-accept]").addEventListener("change", () => render(!1)),
      $("[data-logo-upload]").addEventListener("change", (ev) =>
        upload([...ev.target.files]),
      ),
      $("[data-cart]").addEventListener("submit", send));
    const point = (ev) => {
      const b = editor.getBoundingClientRect(),
        z =
          state.range === "visser"
            ? { x: 0.029, y: 0.845, w: 0.94, h: 0.102 }
            : { x: 0.029, y: 0.832, w: 0.94, h: 0.132 };
      return {
        x: (((ev.clientX - b.left) / b.width - z.x) / z.w) * W,
        y: (((ev.clientY - b.top) / b.height - z.y) / z.h) * H,
      };
    };
    (editor.addEventListener("pointerdown", (ev) => {
      if (busy) return;
      const p = point(ev);
      if (p.x < 0 || p.x > W || p.y < 0 || p.y > H) return;
      const target = [...state.elements]
        .reverse()
        .find(
          (e) =>
            p.x >= e.x - 8 &&
            p.x <= e.x + e.w + 8 &&
            p.y >= e.y - 8 &&
            p.y <= e.y + e.h + 8,
        );
      if (!target) {
        ((selected = null), render());
        return;
      }
      ((selected = target.id),
        checkpoint(),
        (drag = {
          id: target.id,
          x: p.x,
          y: p.y,
          originX: target.x,
          originY: target.y,
          size: target.size,
          w: target.w,
          h: target.h,
        }),
        editor.setPointerCapture(ev.pointerId),
        render(),
        ev.preventDefault());
    }),
      editor.addEventListener("pointermove", (ev) => {
        if (!drag) return;
        const e = el(),
          p = point(ev),
          before = { ...e };
        ((e.x = drag.originX + p.x - drag.x),
          (e.y = drag.originY + p.y - drag.y),
          constrain(e) || Object.assign(e, before),
          drawPreview(cv, !0),
          displayProperties());
      }));
    const finishDrag = () => {
      drag && ((drag = null), save(), render());
    };
    (editor.addEventListener("pointerup", finishDrag),
      editor.addEventListener("pointercancel", finishDrag),
      editor.addEventListener("lostpointercapture", finishDrag),
      editor.addEventListener("keydown", (ev) => {
        if (!el() || busy) return;
        const m = ev.shiftKey ? 10 : 2,
          move = {
            ArrowLeft: [-m, 0],
            ArrowRight: [m, 0],
            ArrowUp: [0, -m],
            ArrowDown: [0, m],
          }[ev.key];
        (move &&
          (ev.preventDefault(),
          change(() => {
            ((el().x += move[0]), (el().y += move[1]));
          })),
          ev.key === "Delete" &&
            (ev.preventDefault(),
            change(() => {
              ((state.elements = state.elements.filter(
                (e) => e.id !== selected,
              )),
                (selected = null));
            })));
      }));
    try {
      const saved = JSON.parse(sessionStorage.getItem(key) || "null");
      if (
        saved &&
        saved.version === 1 &&
        Q.includes(saved.qty) &&
        ["visser", "clipser", "luxe"].includes(saved.range) &&
        Array.isArray(saved.elements)
      ) {
        for (const e of saved.elements)
          e.kind === "icon" &&
            ["car", "coupe", "suv"].includes(e.icon) &&
            (e.icon = { car: "car1", coupe: "car2", suv: "car3" }[e.icon]);
        const clean = saved.elements
          .filter((e) =>
            e.kind === "text"
              ? typeof e.text == "string" &&
                FONTS.includes(e.font) &&
                /^#[\da-f]{6}$/i.test(e.color)
              : e.kind === "logo"
                ? typeof e.asset == "string" &&
                  typeof e.ratio == "number" &&
                  e.ratio > 0
                : e.kind === "icon" && Object.hasOwn(ICONS, e.icon),
          )
          .slice(0, 20);
        state = {
          ...state,
          ...saved,
          quantityChosen: saved.quantityChosen ?? !0,
          plates: saved.plates || [],
          elements: clean,
          step: 1,
        };
      }
    } catch {}
    if ((geometry(), !state.elements.length)) {
      const first = {
        id: id(),
        kind: "text",
        text: "PLAKPERSO CARS",
        font: "Arial",
        color: "#ffffff",
        ral: "",
        size: H,
        x: 0,
        y: 0,
      };
      (constrain(first),
        (first.x = (W - first.w) / 2),
        (first.y = (H - first.h) / 2),
        state.elements.push(first),
        save());
    }
    selected =
      state.elements.find((e) => e.kind === "text")?.id ||
      state.elements[0]?.id ||
      null;
    for (const e of state.elements.filter((e2) => e2.kind === "logo"))
      assetStore("get", e.asset)
        .then((file) => {
          if (!file) {
            ((state.elements = state.elements.filter((x) => x.id !== e.id)),
              save(),
              render());
            return;
          }
          (files.set(e.asset, file),
            loadLogo(file)
              .then((image) => {
                (assets.set(e.asset, image), render(!1));
              })
              .catch(() => error(S.error_image)));
        })
        .catch(() => error(S.error_image));
    for (const k of ["visser", "clipser"]) {
      const image = new Image();
      ((image.crossOrigin = "anonymous"),
        (image.onload = () => {
          ((images[k] = image), render(!1));
        }),
        (image.onerror = () => error(S.error_image)),
        (image.src = cfg.images[k]));
    }
    $("[data-icons]").innerHTML = Object.entries(ICONS)
      .map(
        ([k, i]) =>
          `<button type="button" data-icon="${k}" aria-label="${esc(i.label)}" title="${esc(i.label)}">${i.image ? `<img src="${esc(cfg.icons[k])}" alt="" width="120" height="40">` : svgIcon(i)}</button>`,
      )
      .join("");
    function svgIcon(i) {
      return `<svg viewBox="0 0 24 24" width="44" height="44" fill="${i.stroke ? "none" : "currentColor"}" ${i.stroke ? 'stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" stroke-linecap="round"' : ""} aria-hidden="true"><path d="${i.path}" fill-rule="${i.rule || "nonzero"}"/></svg>`;
    }
    for (const [k, url] of Object.entries(cfg.icons)) {
      const img = new Image();
      ((img.crossOrigin = "anonymous"),
        (img.onload = () => {
          if (!ICONS[k]?.luminanceMask) {
            ((iconImages[k] = img), render(!1));
            return;
          }
          const mask = document.createElement("canvas");
          ((mask.width = img.naturalWidth), (mask.height = img.naturalHeight));
          const mx = mask.getContext("2d", { willReadFrequently: !0 });
          mx.drawImage(img, 0, 0);
          const pixels = mx.getImageData(0, 0, mask.width, mask.height);
          let left = mask.width,
            top = mask.height,
            right = 0,
            bottom = 0;
          for (let y = 0; y < mask.height; y++)
            for (let x = 0; x < mask.width; x++) {
              const n = (y * mask.width + x) * 4,
                v = Math.min(
                  pixels.data[n],
                  pixels.data[n + 1],
                  pixels.data[n + 2],
                );
              ((pixels.data[n] = pixels.data[n + 1] = pixels.data[n + 2] = 255),
                (pixels.data[n + 3] = v < 24 ? 0 : v),
                v >= 24 &&
                  ((left = Math.min(left, x)),
                  (right = Math.max(right, x)),
                  (top = Math.min(top, y)),
                  (bottom = Math.max(bottom, y))));
            }
          if ((mx.putImageData(pixels, 0, 0), right <= left || bottom <= top)) {
            error(S.error_image);
            return;
          }
          const crop = document.createElement("canvas");
          ((crop.width = right - left + 1),
            (crop.height = bottom - top + 1),
            crop
              .getContext("2d")
              .drawImage(
                mask,
                left,
                top,
                crop.width,
                crop.height,
                0,
                0,
                crop.width,
                crop.height,
              ));
          const clean = new Image();
          ((clean.onload = () => {
            iconImages[k] = clean;
            const picker = $('[data-icon="' + k + '"] img');
            picker && (picker.src = clean.src);
            for (const e of state.elements.filter(
              (e2) => e2.kind === "icon" && e2.icon === k,
            ))
              (measure(e), constrain(e));
            render(!1);
          }),
            (clean.src = crop.toDataURL("image/png")));
        }),
        (img.onerror = () =>
          error("Une ic\xF4ne n\u2019a pas pu \xEAtre charg\xE9e.")),
        (img.src = url));
    }
    function renderPlates() {
      const plates = state.plates || [];
      (($("[data-plate-list]").innerHTML = plates
        .map(
          (p, i) =>
            `<div class="ppc-layer"><span>${esc(p.number)} \xB7 ${p.quantity} plaque(s) \xB7 ${money(Math.round((p.quantity * cfg.plateVariant.price) / 1.21))} HTVA</span><button type="button" data-delete-plate="${i}" aria-label="Retirer la plaque ${esc(p.number)}">${trash}</button></div>`,
        )
        .join("")),
        ($("[data-plates-summary]").textContent = plates.length
          ? "Plaques en plexi : " +
            plates.map((p) => p.quantity + " \xD7 " + p.number).join(" \xB7 ") +
            " \u2014 " +
            money(
              Math.round(
                plates.reduce(
                  (t, p) => t + p.quantity * cfg.plateVariant.price,
                  0,
                ) / 1.21,
              ),
            ) +
            " HTVA, en suppl\xE9ment du lot de porte-plaques."
          : ""));
    }
    ($("[data-add-plate]").addEventListener("click", () => {
      const input = $("[data-plate-number]"),
        number = input.value.trim().toUpperCase(),
        plain = number.replace(/-/g, ""),
        quantity = Number($("[data-plate-quantity]").value);
      (input.setCustomValidity(
        /^[A-Z0-9-]+$/.test(number) && plain.length > 0 && plain.length <= 8
          ? ""
          : "Utilisez 1-ABC-123 ou jusqu\u2019\xE0 8 lettres et chiffres.",
      ),
        !(
          !input.reportValidity() ||
          !$("[data-plate-quantity]").reportValidity()
        ) &&
          (change(() => state.plates.push({ number, quantity })),
          (input.value = ""),
          renderPlates()));
    }),
      root.addEventListener("click", (ev) => {
        const b = ev.target.closest("[data-delete-plate]");
        b &&
          !busy &&
          (change(() => state.plates.splice(Number(b.dataset.deletePlate), 1)),
          renderPlates());
      }),
      renderPlates(),
      document.fonts.ready.then(() => {
        for (const e of state.elements) constrain(e);
        render();
      }),
      render());
  }
  const start = () =>
    document.querySelectorAll("[data-ppb-configurator]").forEach(init);
  (document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", start)
    : start(),
    document.addEventListener("shopify:section:load", start));
})();
